<nav class="navbar">
  <div
    class="app-selector"
    [appContextMenu]="app"
    (appContextMenuChange)="handleAppChange($event)"
    (appContextMenuOpened)="appContextMenuOpened = $event"
  >
    <div class="app">
      <mat-icon class="app-icon" [svgIcon]="app | appIcon" />
    </div>

    <app-dropdown-label [collapsed]="!appContextMenuOpened" class="font-semibold whitespace-nowrap">
      {{ app | appTitle }}
    </app-dropdown-label>
  </div>

  <div class="filler"></div>

  @if (navBarContent()) {
    <ng-container *ngTemplateOutlet="navBarContent()" />
  }

  <div class="filler"></div>

  <app-navbar-ai-usage-ring class="mr-4" [appearance]="aiUsageAppearance()" />

  <div class="navbar-buttons-item notifications relative">
    @if (notificationsCount > 0) {
      <div
        class="w-6 h-6 leading-6 flex absolute right-0 justify-center items-center pointer-events-none select-none whitespace-nowrap rounded-full bg-error text-white"
        [class.font-semibold]="notificationsCount < 10"
        [style.font-size]="notificationsCount < 10 ? '8px' : '6px'"
      >
        {{ notificationsCount }}
      </div>
    }

    <mat-icon
      svgIcon="button-nav-notification"
      stchPopover
      [stchPopoverArrow]="true"
      [stchPopoverContent]="notificationsTemplate"
      stchPopoverPlacement="bottom"
      [stchPopoverFallbackPlacements]="[]"
      stchPopoverTrigger="click"
      [stchPopoverShowUntil]="closeToken"
    />
  </div>

  <button
    type="button"
    class="workspace-switcher-trigger"
    [class.team-workspace]="switcherAvatar.square"
    spacesContextMenu
    stchPopoverPlacement="topLeft"
    (spacesContextMenuOpened)="spacesContextMenuOpened = $event"
    [attr.aria-expanded]="spacesContextMenuOpened"
    aria-haspopup="menu"
    aria-label="Switch workspace"
  >
    <!-- No name it may show yet (#1302 PM-2): the slot holds the title's place, so the chevron stays
         put, and draws #1180's blocks once the wait has lasted — never the person's name in a team. -->
    @if (workspaceSwitcherTitle(); as title) {
      <span
        class="workspace-switcher-avatar"
        [style.background-color]="switcherAvatar.background"
        [style.color]="switcherAvatar.text"
      >
        {{ switcherAvatar.initials }}
      </span>
      <span class="workspace-switcher-title">{{ title }}</span>
    } @else {
      <span class="workspace-switcher-pending">
        @if (switcherSkeleton()) {
          <app-rail-skeleton variant="switcher" [barWidth]="110" />
        }
      </span>
    }
    <app-icon name="sapphire-chevron-up" size="s" />
  </button>
</nav>

<ng-template #notificationsTemplate>
  <app-notifications-list />
</ng-template>
